module.exports = __webpack_public_path__ + "static/media/earth.54231c06.png";